import axios from "axios";
import { ECustomerType } from "@/struct/customer/ECustomerType";
export default class ApiCustomer {
    static async CreateEmptyCustomer(session_uuid, email, password) {
        try {
            const response = await axios.post("/api/customer/register", {
                email: email,
                password: password
            }, {
                headers: {
                    "x-tenant": "null",
                    "x-session-token": session_uuid
                }
            });
            return response.data.response.session_uuid;
        }
        catch (e) {
            return null;
        }
    }
    static async SetEmptyCustomerPersonalDetails(customer_session_uuid, data) {
        try {
            await axios.post("/api/customer/change/personal", {
                personal_data: {
                    first_name: data.firstName,
                    last_name: data.lastName,
                    birth_data: {
                        birth_at: data.birthDate,
                        birth_city: "",
                        birth_country: ""
                    }
                },
                personal_address: {
                    zip_code: data.addressZipCode,
                    city: data.addressCity,
                    street_name: data.addressStreetName,
                    street_number: data.addressStreetNumber,
                    street_box: data.addressStreetBox
                },
                shipping_address: {
                    zip_code: data.addressZipCode,
                    city: data.addressCity,
                    street_name: data.addressStreetName,
                    street_number: data.addressStreetNumber,
                    street_box: data.addressStreetBox
                }
            }, {
                headers: {
                    "x-session-token": customer_session_uuid
                }
            });
            return true;
        }
        catch (e) {
            return false;
        }
    }
    static async SetEmptyCustomerBusinessDetails(customer_session_uuid, data) {
        try {
            await axios.post("/api/customer/change/business", {
                company_data: {
                    company_name: data.companyName,
                    vat_number: data.companyVAT,
                    name_of_legal: data.firstName,
                    surname_of_legal: data.lastName
                },
                company_address: {
                    zip_code: data.addressZipCode,
                    city: data.addressCity,
                    street_name: data.addressStreetName,
                    street_number: data.addressStreetNumber,
                    street_box: data.addressStreetBox
                },
                shipping_address: {
                    zip_code: data.addressZipCode,
                    city: data.addressCity,
                    street_name: data.addressStreetName,
                    street_number: data.addressStreetNumber,
                    street_box: data.addressStreetBox
                }
            }, {
                headers: {
                    "x-session-token": customer_session_uuid
                }
            });
            return true;
        }
        catch (e) {
            return false;
        }
    }
    static async ChangeCustomerPersonalDetails(customer_session_uuid, customer_uuid, data) {
        try {
            await axios.post(`/api/admin/v2/customer/${customer_uuid}/change/personal`, {
                personal_data: {
                    first_name: data.firstName,
                    last_name: data.lastName,
                    birth_data: {
                        birth_at: data.birthDate,
                        birth_city: "",
                        birth_country: ""
                    }
                },
                personal_address: {
                    zip_code: data.addressZipCode,
                    city: data.addressCity,
                    street_name: data.addressStreetName,
                    street_number: data.addressStreetNumber,
                    street_box: data.addressStreetBox
                },
                shipping_address: {
                    zip_code: data.addressZipCode,
                    city: data.addressCity,
                    street_name: data.addressStreetName,
                    street_number: data.addressStreetNumber,
                    street_box: data.addressStreetBox
                }
            }, {
                headers: {
                    "x-session-token": customer_session_uuid
                }
            });
            return true;
        }
        catch (e) {
            return false;
        }
    }
    static async ChangeCustomerBusinessDetails(customer_session_uuid, customer_uuid, data) {
        try {
            await axios.post(`/api/admin/v2/customer/${customer_uuid}/change/business`, {
                company_data: {
                    company_name: data.companyName,
                    vat_number: data.companyVAT,
                    name_of_legal: data.firstName,
                    surname_of_legal: data.lastName
                },
                company_address: {
                    zip_code: data.addressZipCode,
                    city: data.addressCity,
                    street_name: data.addressStreetName,
                    street_number: data.addressStreetNumber,
                    street_box: data.addressStreetBox
                },
                shipping_address: {
                    zip_code: data.addressZipCode,
                    city: data.addressCity,
                    street_name: data.addressStreetName,
                    street_number: data.addressStreetNumber,
                    street_box: data.addressStreetBox
                }
            }, {
                headers: {
                    "x-session-token": customer_session_uuid
                }
            });
            return true;
        }
        catch (e) {
            return false;
        }
    }
    static async ConfirmCustomerEmail(session_uuid, email) {
        try {
            await axios.get(`/api/debug/customer/email/confirm?search=${email}`, {
                headers: {
                    "x-tenant": "null",
                    "x-session-token": session_uuid
                }
            });
            return true;
        }
        catch (e) {
            return false;
        }
    }
    static async ChangeCustomerPassword(session_uuid, email, new_password) {
        try {
            await axios.post(`/api/admin/v2/customer/change-password`, { email: email, new_password: new_password }, { headers: { "x-tenant": "null", "x-session-token": session_uuid } });
            return true;
        }
        catch (e) {
            return false;
        }
    }
    static async UpdateCustomer(session_uuid, customer_uuid, data) {
        try {
            if (data.type == ECustomerType.Personal) {
                return await this.ChangeCustomerPersonalDetails(session_uuid, customer_uuid, data);
            }
            return await this.ChangeCustomerBusinessDetails(session_uuid, customer_uuid, data);
        }
        catch (e) {
            throw new Error("Error update customer");
        }
    }
    static async CreateCustomer(session_uuid, data, options) {
        try {
            const emptyCustomerSessionUUID = await this.CreateEmptyCustomer(session_uuid, data.email, data.password);
            if (!emptyCustomerSessionUUID) {
                return false;
            }
            let customerDataSuccess = false;
            if (data.type == ECustomerType.Personal) {
                customerDataSuccess = await this.SetEmptyCustomerPersonalDetails(emptyCustomerSessionUUID, data);
            }
            else {
                customerDataSuccess = await this.SetEmptyCustomerBusinessDetails(emptyCustomerSessionUUID, data);
            }
            if (options?.confirmEmail) {
                await this.ConfirmCustomerEmail(session_uuid, data.email);
            }
            return customerDataSuccess;
        }
        catch (e) {
            throw new Error("Error create customer");
        }
    }
    static async DeleteCustomer(session_uuid, customer_uuid) {
        try {
            await axios.post("/api/admin/v2/customer/delete", {
                customer_uuid: customer_uuid
            }, {
                headers: {
                    "x-tenant": "null",
                    "x-session-token": session_uuid
                }
            });
            return true;
        }
        catch (e) {
            return false;
        }
    }
    static async GetCustomerInformation(session_uuid) {
        try {
            const result = await axios.get("/api/admin/customer/list", {
                headers: {
                    "x-tenant": "null",
                    "x-session-token": session_uuid
                }
            });
            return result.data.response;
        }
        catch (e) {
            throw new Error("Error get customers");
        }
    }
    static async GetCustomerInformationByUUID(session_uuid, uuid) {
        try {
            const result = await axios.get(`/api/admin/v2/customer/${uuid}`, {
                headers: {
                    "x-tenant": "null",
                    "x-session-token": session_uuid
                }
            });
            return result.data.response;
        }
        catch (e) {
            throw new Error("Error get customer");
        }
    }
    static async AssignIBAN(session_uuid, customer_uuid) {
        try {
            const result = await axios.post(`/api/admin/v2/customer/${customer_uuid}/assign-iban`, undefined, {
                headers: {
                    "x-tenant": "null",
                    "x-session-token": session_uuid
                }
            });
            return { success: true, response: result.data.response };
        }
        catch (e) {
            return { success: false, response: e?.response?.data?.error?.message || "Unknown error" };
        }
    }
}
